import { render, staticRenderFns } from "./clueDetail.vue?vue&type=template&id=0bce1b10&scoped=true"
import script from "./clueDetail.vue?vue&type=script&lang=js"
export * from "./clueDetail.vue?vue&type=script&lang=js"
import style0 from "./clueDetail.vue?vue&type=style&index=0&id=0bce1b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce1b10",
  null
  
)

export default component.exports